import styled from 'styled-components';
import { InputV2, ButtonV2 } from '@getgrover/ui';

const Form = styled.form`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
`;

const FormRow = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 16px;
`;

const Input = styled(InputV2)`
    &:nth-child(2) {
        margin-left: 40px;
        flex: 1;
    }
    flex: 2;
`;

const ErrorText = styled.p`
    line-height: 1.35;
    color: #f44336;
    font-style: italic;
    font-weight: bold;
    font-size: 0.8em;
    letter-spacing: 0.02em;
`;

const SubmitButton = styled(ButtonV2)`
    margin-top: 24px;
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

export { Form, FormRow, Input, ErrorText, SubmitButton };
